import React from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';

import { setBackgroundDefault, setBackgroundLanding } from '../../../redux/page/pageActions';
import { getFlagProperty, setFlag } from '../../../redux/flags/flags';

import LandingMainCard from './LandingMainCard';
import { Revealer, HeadWrapper } from '../../../elements';

const mapStateToProps = (state) => ({
  isPageRevealerHidden: getFlagProperty(state, 'isPageRevealerHidden'),
});

const mapDispatchToProps = {
  setFlag,
};

class LandingPage extends React.Component {
  static propTypes = {
    isPageRevealerHidden: bool,
    setFlag: func,
  };

  componentDidMount() {
    setBackgroundLanding();
    this.props.setFlag('isHeaderHome', true);
  }

  componentWillUnmount() {
    setBackgroundDefault();
    this.props.setFlag('isHeaderHome', false);
  }

  handleRevealerAnimationProgress = () => {
    this.props.setFlag('isPageAnimationsUnblocked', true);
  };

  handleRevealerAnimationEnd = () => {
    this.props.setFlag('isPageRevealerHidden', true);
  };

  render() {
    const { isPageRevealerHidden, history } = this.props;
    return (
      <>
        <HeadWrapper
          href="https://developer.staq.io/"
        >
          <script type="application/ld+json">
            { `"@context": "https://schema.org",
            "@type": "Organization",
            "@id": "developer.staq.io",
            "name": "Staq Developer Portal",
            "url": "developer.staq.io",
            "logo": "https://assets-global.website-files.com/6515868c5254d53c25ee349f/6515868c5254d53c25ee34c4_Vectors-Wrapper.svg",
            "sameAs": [
            "https://www.linkedin.com/company/staqio/about/",
            "https://twitter.com/staqio",
            "https://github.com/staq-io"
            ]`}
          </script>

        </HeadWrapper>
        {/* TODO: TEMP. consider moving to own component */}
        {!isPageRevealerHidden && (
          <Revealer
            onAnimationEnd={this.handleRevealerAnimationEnd}
            onProgress={{
              80: this.handleRevealerAnimationProgress,
            }}
          />
        )}
        <LandingMainCard history={history}/>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
